import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "./CredentialManagement.scss";
import {
  ApiDelete,
  ApiGet,
  ApiPost,
  ApiPut,
} from "../../../helpers/API/ApiData";

import { customStyles } from "../tableStyle";
import { TailSpin } from "react-loader-spinner";

import { toast } from "react-toastify";
import useDebounce from "../../../hooks/useDebounceHook";

import Swal from "sweetalert2";
import { Button } from "reactstrap";

import { Modal } from "react-bootstrap";
import { useOnChange } from "../../../hooks/onChangeHooks";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./CredentialManagement.scss";
import plusIcon from "../../../assets/icon/plus-icon.svg";
import Select from "react-select";
import { ValidateParkingOwnerForm } from "./ValidateParkingOwnerForm";
import AddParkingOwnerDetails from "./AddParkingOwnerDetails";

export default function AddParkingOwner() {
  const [getNewsData, setGetNewsData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isAddUser, setIsAddUser] = useState(false);
  const [fileType, setfileType] = useState("");
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [FormType, setFormType] = useState("");
  const [loading, setLoading] = useState(false);
  const [UpdatePassword, setUpdatePassword] = useState(false);
  const [buttonLoading, setbuttonloading] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue, 900);
  const [image, setImage] = useState("");
  const [newimage, setNewImage] = useState("");
  const [close, setClose] = useState(false);
  const [newClose, setNewClose] = useState(false);
  const [uploadImage, setUploadImage] = useState("");
  const [isActive, setISActive] = useState();
  const [status, setStatus] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [checked, setChecked] = useState(false);
  const [projectList, setProjectList] = useState();
  const [salesPatner, setSalesPatner] = useState();
  const [VattenfallsalesPatner, setVattenfallSalesPartner] = useState();
  const [selectedPatner, setSelectedSalesPatner] = useState([]);
  const [selectedVattenfallPartner, setSelectedVattenfallPartner] = useState(
    []
  );
  const [vattenfallChecked, setVattenfallChecked] = useState(false);

  const [project, setProject] = useState();

  const { inputValue, setInputValue, errors, setErrors, handleChange } =
    useOnChange({});

  const columns = [
    {
      name: "S.No",
      cell: (row, index) => {
        return <p>{(page - 1) * countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: "Aktion",
      selector: (row) => (
        <div className="actionColumn">
          <Button
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => updateNewsData(row)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="pencilIcon"
              aria-hidden="true"
              width="20"
              height="20"
            >
              <path d="M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25zM22.71 5.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 00-1.41 0L16.34 3.34l3.75 3.75 2.62-2.62z" />
            </svg>
          </Button>
          <button
            onClick={() => handleConfirmDelete(row)}
            className={`btn btn  ${row?.isActive ? "sucessfull" : "danger"}`}
          >
            <span>{row?.isActive ? "aktiv" : "inactiv"}</span>
          </button>
        </div>
      ),
    },
    {
      name: "Benutzername",
      width: "250px",
      selector: (row) => {
        return <div>{row?.name ? row?.name : ""}</div>;
      },
    },
    {
      name: "Vorname",
      width: "250px",
      selector: (row) => {
        return <div>{row?.vorname ? row?.vorname : ""}</div>;
      },
    },
    {
      name: "Nachname",
      width: "250px",
      selector: (row) => {
        return <div>{row?.nachname ? row?.nachname : ""}</div>;
      },
    },
    {
      name: "E-mail",
      width: "250px",
      selector: (row) => {
        return <div>{row?.email ? row?.email : ""}</div>;
      },
    },
    {
      name: "Telefon",
      width: "250px",
      selector: (row) => {
        return <div>{row?.phone ? row?.phone : ""}</div>;
      },
    },
  ];

  const handleAddNewsClose = () => {
    setIsAddUser(false);
    setInputValue({});
    setErrors({});
    setFormType("add");
    setUpdatePassword(false);
    setbuttonloading(false);
    setUploadImage("");
    setVattenfallChecked(false);
  };

  const updateNewsData = (row) => {
    setInputValue({
      name: row?.name,
      vorname: row?.vorname,
      nachname: row?.nachname,

      email: row?.email,
      phone: row?.phone,

      id: row?._id,

      vattenfallPatners: row?.parkingplotDetails?.map((item) => {
        const data = {
          value: item?._id,
          label: item?.name,
        };
        return data;
      }),
    });
    if (row?.parkingplotDetails.length > 0) {
      setVattenfallChecked(true);
    }
    setChecked(row?.PVVertrieb);

    setIsAddUser(true);
    setFormType("update");
  };

  const handleValidateForm = () => {
    const error = ValidateParkingOwnerForm(
      inputValue,
      FormType,
      UpdatePassword,
      false
    );

    setErrors(error?.error);
    return error?.isValid;
  };

  const handleAddUser = () => {
    if (handleValidateForm()) {
      setLoading(true);
      let formData = new FormData();
      formData.append("name", inputValue?.name ? inputValue?.name : "");
      formData.append("email", inputValue?.email ? inputValue?.email : "");
      formData.append(
        "password",
        inputValue?.password ? inputValue?.password : ""
      );
      formData.append(
        "vorname",
        inputValue?.vorname ? inputValue?.vorname : ""
      );
      formData.append(
        "nachname",
        inputValue?.nachname ? inputValue?.nachname : ""
      );
      if (inputValue?.phone) {
        formData.append("phone", inputValue?.phone ? inputValue?.phone : "");
      }
      formData.append("role", "super_admin");
      // if (inputValue?.vattenfallPatners?.length > 0) {
      //   inputValue?.vattenfallPatners?.forEach((ele, i) => {
      //     if (ele?.value) {
      //       formData.append(`parkingplot[${i}]`, ele?.value);
      //     }
      //   });
      // }
      if (inputValue?.vattenfallPatners?.length > 0) {
        for (let i = 0; i < inputValue.vattenfallPatners.length; i++) {
          const ele = inputValue.vattenfallPatners[i];
          if (ele?.value) {
            formData.append(`parkingplot[${i}]`, ele.value);
          }
        }
      }

      ApiPost(`user/signup`, formData)
        .then((res) => {
          toast.success("Parkplatzbesitzer erfolgreich hinzugefügt");
          handleAddNewsClose();
          setLoading(false);
          handleGetNewsList();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setLoading(false);
          handleAddNewsClose();
        });
    }
  };

  const handleUpdateUser = (row) => {
    if (handleValidateForm()) {
      let formData = new FormData();
      if (inputValue?.name) {
        formData.append("name", inputValue?.name ? inputValue?.name : "");
      }
      // formData.append("email", inputValue?.email ? inputValue?.email : "");

      if (inputValue?.vorname) {
        formData.append(
          "vorname",
          inputValue?.vorname ? inputValue?.vorname : ""
        );
      }
      if (inputValue?.nachname) {
        formData.append(
          "nachname",
          inputValue?.nachname ? inputValue?.nachname : ""
        );
      }
      if (inputValue?.phone) {
        formData.append("phone", inputValue?.phone ? inputValue?.phone : "");
      }
      formData.append("role", "super_admin");
      // if (inputValue?.vattenfallPatners?.length > 0) {
      //   inputValue?.vattenfallPatners?.forEach((ele, i) => {
      //     if (ele?.value) {
      //       formData.append(`parkingplot[${i}]`, ele?.value);
      //     }
      //   });
      // }

      if (inputValue?.vattenfallPatners?.length > 0) {
        for (let i = 0; i < inputValue.vattenfallPatners.length; i++) {
          const ele = inputValue.vattenfallPatners[i];
          if (ele?.value) {
            formData.append(`parkingplot[${i}]`, ele.value);
          }
        }
      }

      if (inputValue?.password) {
        inputValue?.password?.trim() &&
          formData.append("password", inputValue?.password?.trim());
      }
      setbuttonloading(true);

      ApiPut(`user/parkinglotownerupdate?id=${inputValue?.id}`, formData)
        .then((res) => {
          toast.success("Benutzer erfolgreich aktualisiert");
          setbuttonloading(false);
          handleAddNewsClose();
          setSelectedSalesPatner("");
          handleGetNewsList();
          setUploadImage("");
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setbuttonloading(false);
        });
    }
  };

  const handleDeleteNewsInfo = async (row) => {
    setLoading(true);
    let response = false;
    if (row?.isActive) {
      await ApiDelete(`user/deleteUser?id=${row?._id}`)
        .then((res) => {
          setLoading(false);
          handleGetNewsList();
          response = true;
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      await ApiPut(`user/reactivateUser?id=${row?._id}`)
        .then((res) => {
          setLoading(false);
          handleGetNewsList();
          response = true;
        })
        .catch((err) => {
          setLoading(false);
        });
    }
    return response;
  };

  const handleConfirmDelete = (row) => {
    return Swal.fire({
      title: "Bist du dir sicher?",
      text: "Deaktivierung bestätigen",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ja, deaktivieren",
      cancelButtonText: "Abbrechen",
      customClass: {
        confirmButton: "btn btn-primary mr-10",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
    }).then(async function (result) {
      if (result?.value) {
        const res = await handleDeleteNewsInfo(row);

        if (res) {
          Swal.fire({
            icon: "success",
            title: "Gelöscht!",
            text: "Vertriebspartner gelöscht.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else {
          Swal.fire({
            title: "Abgbrochen",
            text: "Deaktivierung abgebrochen!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Abgbrochen",
          text: "Deaktivierung abgebrochen!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  };
  const formatDate = (date) => {
    if (!date) return "";
    const adjustedDate = new Date(
      date.getTime() + Math.abs(date.getTimezoneOffset() * 60000)
    );
    return adjustedDate.toISOString().split("T")[0];
  };
  const handleGetNewsList = async () => {
    setLoading(true);
    await ApiGet(
      `user/getParkingLotOwner?page=${page}${
        debouncedSearchValue ? `&search=${searchValue}` : ""
      }&limit=${countPerPage}${isActive ? `&isActive=${isActive?.value}` : ""}${
        status ? `&status=${status?.value}` : ""
      }${startDate ? `&startDate=${formatDate(startDate)}` : ""}${
        endDate ? `&endDate=${formatDate(endDate)}` : ""
      }${status ? `&sortBy=straperCount` : ""}${status ? `&sortOrder=-1` : ""}${
        project ? `&projectName=${encodeURIComponent(project?.label)}` : ""
      }`
    )
      .then((response) => {
        const data = response?.data?.payload.data;
        setCount(response?.data?.payload.count);
        setGetNewsData(response?.data?.payload.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetNewsList();
  }, [
    debouncedSearchValue,
    page,
    countPerPage,
    isActive,
    status,
    startDate,
    endDate,
    project,
  ]);
  const statusData = [
    {
      label: "inaktiv",
      value: false,
    },
    {
      label: "aktiv ",
      value: true,
    },
  ];

  const ProjectStyle = {
    control: (provided, state) => ({
      ...provided,
      maxWidth: "150px",
      fontSize: "12px",
      marginLeft: "30px",
      border: state.isFocused ? "2px solid #73AA85 !important" : "",
      boxShadow: "1px solid #73AA85 !important",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      color: state.isSelected ? "white" : "black", // Change selected color here
      backgroundColor: state.isSelected ? "#73AA85" : "white",
      "&:hover": {
        backgroundColor: "#73AA85",
      },
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "150px",
      marginLeft: "30px",
      zIndex: "999",
    }),
  };
  const handleOnChanges = (data) => {
    setISActive(data);
  };

  const handleProjektList = async () => {
    await ApiGet(`project/get`)
      .then((response) => {
        let projectedData = response?.data?.payload.data.map((item) => {
          let data = {
            value: item?._id,
            label: item?.projectname,
          };
          return data;
        });
        setProjectList(projectedData);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    handleProjektList();
  }, []);

  const handleOnNewProjectChanges = (data) => {
    setProject(data);
  };
  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="row mb-4 pr-3 row-alignment-top d-flex justify-content-between">
            <div className="col-12 col-lg-3 d-flex align-items-center Vertriebspartner-alignment Vertriebspartner-alignment-mobile">
              <h2 className="pl-7 pt-2 new-head-design">Parkplatzbesitzer</h2>
              <div className="filter-user">
                <Select
                  className="dropdown-align"
                  value={isActive}
                  onChange={handleOnChanges}
                  options={statusData}
                  maxHeight={"100px"}
                  styles={ProjectStyle}
                  placeholder="Status"
                  isClearable
                />
              </div>
            </div>

            <div className="col-lg-7 col-md-5 align-items-center row suche-button-input-flx-main">
              <div className="col col-lg-5">
                <div>
                  <input
                    type="search"
                    className={`form-control form-control-lg form-control-solid  custom-input`}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      setLoading(true);
                    }}
                    name="search"
                    value={searchValue}
                    placeholder="Suche"
                  />
                </div>
              </div>
              <div className="filter-button-mobile">
                <div className="filter-user">
                  <Select
                    className="dropdown-align"
                    value={isActive}
                    onChange={handleOnChanges}
                    options={statusData}
                    maxHeight={"100px"}
                    styles={ProjectStyle}
                    placeholder="Status"
                    isClearable
                  />
                </div>

                <div className="cus-medium-button-style button-height pr-2 mt-lg-0 cusbutton-moblie">
                  <button
                    onClick={() => {
                      setIsAddUser(true);
                      setFormType("add");
                    }}
                    className="btn btn addbutton"
                    style={{ display: "flex", gap: "5px" }}
                  >
                    <img src={plusIcon} /> Parkplatzbesitzer
                  </button>
                </div>
              </div>
              <div className="filter-user filter-user-sc">
                <Select
                  className="dropdown-align-pp"
                  value={project}
                  onChange={handleOnNewProjectChanges}
                  options={projectList}
                  maxHeight={"100px"}
                  styles={ProjectStyle}
                  placeholder="Projekt"
                  isClearable
                />
              </div>
            </div>
          </div>
          <DataTable
            data={getNewsData}
            columns={columns}
            responsive
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={page}
            progressPending={loading}
            progressComponent={
              <TailSpin color="#334D52" height={30} width={30} />
            }
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
            fixedHeader
          />
        </div>
        <Modal
          show={isAddUser}
          onHide={handleAddNewsClose}
          className="d-flex justify-content-center align-items-center"
        >
          <AddParkingOwnerDetails
            UpdatePassword={UpdatePassword}
            setUpdatePassword={setUpdatePassword}
            inputValue={inputValue}
            handleChange={handleChange}
            errors={errors}
            handleAddNews={
              FormType === "add" ? handleAddUser : handleUpdateUser
            }
            setInputValue={setInputValue}
            setSalesPatner={setSalesPatner}
            VattenfallsalesPatner={VattenfallsalesPatner}
            setVattenfallSalesPartner={setVattenfallSalesPartner}
            salesPatner={salesPatner}
            formType={FormType}
            loading={loading}
            handleOnClose={handleAddNewsClose}
            buttonLoading={buttonLoading}
            getNewsData={getNewsData}
            setErrors={setErrors}
            setUploadImage={setUploadImage}
            uploadImage={uploadImage}
            setChecked={setChecked}
            checked={checked}
            setSelectedSalesPatner={setSelectedSalesPatner}
            selectedPatner={selectedPatner}
            vattenfallChecked={vattenfallChecked}
            setVattenfallChecked={setVattenfallChecked}
            setSelectedVattenfallPartner={setSelectedVattenfallPartner}
            selectedVattenfallPartner={selectedVattenfallPartner}
          />
        </Modal>
      </div>
      {close && (
        <div className="new__imagemodel">
          <div className="body_model"></div>
          <div className="new-white-box">
            <div className="header_close">
              <i
                onClick={() => {
                  setClose(!close);
                  setImage("");
                }}
                className="fas fa-window-close modalClose"
              ></i>
            </div>
            <div className="image_body">
              <img className="modal-image" src={image} />
            </div>
          </div>
        </div>
      )}

      {newClose && (
        <div className="new__imagemodel">
          <div className="body_model"></div>
          <div className="new-white-box">
            <div className="header_close">
              <i
                onClick={() => {
                  setNewClose(!newClose);
                  setNewImage("");
                }}
                className="fas fa-window-close modalClose"
              ></i>
            </div>
            <div className="image_body">
              {fileType == "svg" ||
              fileType == "png" ||
              fileType == "jpg" ||
              fileType == "jpeg" ? (
                <>
                  <img className="modal-image" src={newimage} />
                </>
              ) : fileType === "pdf" ? (
                <>
                  <object
                    data={newimage}
                    type="application/pdf"
                    width="420px"
                    height="650px"
                  ></object>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
